module.exports = __webpack_public_path__ + "static/media/instructivova2.de440399.png";